module.exports = __webpack_public_path__ + "img/settings.36e0ee92.png";